import React from "react";

export default function AboutStory() {
  return (
    <div className="container-lookers py-20 max-w-2xl" data-testid="about-page">
      <h1 className="font-serif text-5xl mb-6 text-zinc-900">
        Take Another Look.
      </h1>
      <p className="text-sm text-zinc-500 mb-4 leading-relaxed">
        Designer frames don't suddenly stop being great frames because someone else wore them first. Styles change. Prescriptions change. People move on.
      </p>
      <p className="text-sm text-zinc-500 mb-4 leading-relaxed">
        But many quality frames still have years of life left in them. Lookers finds preloved designer eyewear worth wearing again, individually inspects every pair and gives you a clear Condition Rating before you buy.
      </p>
      <p className="text-sm text-zinc-500 leading-relaxed">
        Because sometimes the best new look isn't new at all. We're not asking you to lower your standards because you're buying preloved — better brands, better value, less waste. The product remains desirable. Only the ownership history is different.
      </p>
    </div>
  );
}
